export const version = "transactions/5.6.2";
//# sourceMappingURL=_version.js.map